import { useJobStore } from '@stores/job.store'

import { MouseEvent, useCallback, useState } from 'react'

import type { JobPageItem, TermsConditions } from '@types'

import Button from '@components/buttons/button'
import ApplyDisclaimer from '@components/job/apply-disclaimer'
import useAddEventListener from '@hooks/useAddEventListener'

import styles from './scroll-apply-button.module.scss'

type ScrollButtonProps = {
  applyClick: (event: MouseEvent) => void
  isEligibleToApply: boolean
  jobSource: JobPageItem['source']
  legals: TermsConditions[]
}

export default function ScrollApplyButton({
  applyClick,
  legals,
  jobSource,
  isEligibleToApply,
}: ScrollButtonProps): JSX.Element {
  const [scrollApply, setScrollApply] = useState<string>(styles.scrolled)

  const isApplied = useJobStore((state) => state.isApplied)
  const handleScroll = useCallback(() => {
    // 100 is height of navbar
    if (window.scrollY <= 400) {
      setScrollApply(styles.scrolled)
    } else {
      setScrollApply('')
    }
  }, [])

  useAddEventListener('scroll', handleScroll)

  return (
    <div className={`${styles['mobile-apply']} ${scrollApply}`}>
      <div className={styles.apply}>
        <Button onClick={applyClick} disabled={isApplied} variant="yellow">
          {isApplied ? 'Applied!' : 'Apply now'}
        </Button>
      </div>
      <ApplyDisclaimer termsConditions={legals} jobSource={jobSource} isEligibleToApply={isEligibleToApply} />
    </div>
  )
}
